import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import * as Wallet from '../../../wallet/api';
export const getRaces = createAsyncThunk('results/races', async (filter) => {
    try {
        return await Wallet.getRaces(filter);
    }
    catch (err) {
        return err.response;
    }
});
export const getRaceById = createAsyncThunk('result/id', async (id) => {
    try {
        return await Wallet.getRaceInfo(id);
    }
    catch (err) {
        return err.response;
    }
});
const clearData = (state) => {
    state.pending = false;
    state.error = null;
    state.raceResult = null;
    state.raceResults = [];
    state.filtersValue = null;
};
export const initialState = {
    pending: false,
    error: null,
    filtersValue: null,
    raceResults: [],
    raceResult: null
};
export const resultsSlice = createSlice({
    name: 'results',
    initialState,
    reducers: {
        saveFilterData: (state, action) => {
            state.filtersValue = action.payload;
        },
        clearResultsData: (state) => {
            clearData(state);
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getRaces.pending, (state) => {
            state.pending = true;
        });
        builder.addCase(getRaces.fulfilled, (state, action) => {
            state.pending = false;
            state.raceResults = action.payload;
        });
        builder.addCase(getRaces.rejected, (state, action) => {
            state.pending = false;
        });
        builder.addCase(getRaceById.fulfilled, (state, action) => {
            state.pending = false;
            state.raceResult = action.payload;
        });
    }
});
export const { saveFilterData, clearResultsData } = resultsSlice.actions;
export default resultsSlice.reducer;
